/**
 * TimelineFilterHeader Component
 *
 * Displays the header section of the filter popover with title and clear button.
 */

import React from "react";
import { Button } from "@/components/ui/button";
import { FilterX } from "lucide-react";

interface TimelineFilterHeaderProps {
  activeFilterCount: number;
  onClearAll: () => void;
}

const TimelineFilterHeaderBase: React.FC<TimelineFilterHeaderProps> = ({
  activeFilterCount,
  onClearAll,
}) => {
  return (
    <div className="flex items-center justify-between pb-2 border-b">
      <div>
        <h4 className="font-semibold text-lg text-card-foreground">
          Timeline Filters
        </h4>
        <p className="text-sm text-gray-500">
          Customize what timeline items to show
        </p>
      </div>
      {activeFilterCount > 0 && (
        <Button
          variant="outline"
          size="sm"
          onClick={onClearAll}
          className="text-red-600 border-red-200 hover:bg-red-50"
        >
          <FilterX className="h-4 w-4 mr-1" />
          Clear all
        </Button>
      )}
    </div>
  );
};

export const TimelineFilterHeader = React.memo(TimelineFilterHeaderBase);
